import { FormProperty } from '../../enums';

export const BaseFilterForm = {
  Location: 'location',
  DatePeriod: 'datePeriod',
};

export const BaseFilterProperty = {
  ...FormProperty,
  LocationFormTitle: 'locationFormTitle',
  DatePeriodFormTitle: 'datePeriodFormTitle',
};
